import { defineStore } from 'pinia'
// import { en } from 'primelocale/js/en.js'
// import { es } from 'primelocale/js/es.js'
// import { usePrimeVue } from 'primevue'
import { ref } from 'vue'

export const useUserStore = defineStore('user', () => {
  const username = ref(null)
  const perms = ref(null)

  // choose language based on user's navigator preferences
  // 1. the first one in the list of prefered languages
  // 2. remove variant if present (en-GB => en)
  // 3. choose between english or spanish (english if no match)
  const primary = navigator.language.split('-')[0]
  const available = ['en', 'es']
  const lang = ref(available.includes(primary) ? primary : 'en')

  const dark = ref(false)

  function login(username_, permissions) {
    username.value = username_
    perms.value = permissions
    console.log('Permisos recibidos', perms.value)
  }

  function logout() {
    username.value = null
    perms.value = null
  }

  function set_language(lang_) {
    lang.value = lang_
  }

  function set_dark(dark_) {
    dark.value = dark_
  }

  // watch(lang, (lang_) => {
  //   // set Vue-i18n language
  //   // locale.value = store.lang
  //   locale.value = lang_
  //   // set Primevue language
  //   const primevue = usePrimeVue()
  //   const languages = { en, es }
  //   primevue.config.locale = languages[lang_]
  // })

  return { username, perms, lang, dark, login, logout, set_language, set_dark }
})
